export default __webpack_public_path__ + "_/videos/lootbox/video-default-88d79fec84f1c06d5e508ee4b61dcee88d413d78dc590ff1683ddb4e7df6852c.mp4";